/**
 * @description Stateless Module for the boolean toggle button 
 * @param
 */
import * as React from "react";

interface ToggleSelectProps {
  title: string,
  isHidden: boolean,
  onClick?: any
}
interface LabelShowProps {
  labelList: any
}
export const ToggleSelect: React.SFC<ToggleSelectProps> = (props) => <input type='button' value={props.title}
  className={`yesOrNoButton pull-right ${props.isHidden ? 'active' : ''}`}
  onClick={props.onClick} />




export const RenderLabel: React.SFC<LabelShowProps> = (props) => {

  let itemList = props.labelList;
  let classname = `col-sm-${itemList.length - 1 || 2} smart-column brandon-bold`
  return <div>
    <p>&nbsp;</p>
    <div className="row headerMargin">
      {
        itemList.map((ele: any) => {

          return (<div className={ele.width ? `col-sm-${ele.width} smart-column brandon-bold` : classname}>
            {ele.value}
          </div>)
        })
      }
    </div>
  </div>
}

export const SpacingArea: React.SFC = () => {

  return <p>&nbsp;</p>
}